// extracted by mini-css-extract-plugin
module.exports = {"icon":"CustomPanelHeader_icon__XXMne","row":"CustomPanelHeader_row__kZ3Zs"};